import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const AccountantHome = lazy(() => import("../Components/ProfilesType/Accountants/AccountantHome/AccountantHome"));
const BookingsPayout = lazy(() => import("../Components/ProfilesType/Accountants/AccountantBookings/BookingsPayout"));
const ReferralsPayout = lazy(() => import("../Components/ProfilesType/Accountants/AccountantReferrals/ReferralsPayout"));

export const accountRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><AccountantHome /></Suspense>,
    },
    {
        path: "bookings",
        element: <Suspense fallback={<GlobalLoading />}><BookingsPayout /></Suspense>,
    },
    {
        path: "referrals",
        element: <Suspense fallback={<GlobalLoading />}><ReferralsPayout /></Suspense>,
    },
]